(function () {
	function onScrollAnimate() {
		var elements = document.querySelectorAll('.animated');
		if (!elements.length) return;
		var scrollPos = window.pageYOffset || document.documentElement.scrollTop;
		var wh = window.innerHeight;
		for (var i = 0; i < elements.length; i++) {
			var el = elements[i];
			var animClass = el.getAttribute('data-animate');
			if (!animClass) continue;
			var rect = el.getBoundingClientRect();
			var elemOffset = rect.top + scrollPos;
			if (scrollPos > elemOffset - wh + 200) {
				el.classList.add(animClass);
			}
		}
	}

	function onScrollParallax() {
		var nodes = document.querySelectorAll('.js-top-parallax');
		if (!nodes.length) return;
		var y = window.pageYOffset || document.documentElement.scrollTop;
		var pos = 'center ' + parseInt(-y / 25, 10) + 'px';
		for (var i = 0; i < nodes.length; i++) {
			nodes[i].style.backgroundPosition = pos;
		}
	}

	function initParallax() {
		var nodes = document.querySelectorAll('.js-top-parallax');
		for (var i = 0; i < nodes.length; i++) {
			nodes[i].style.backgroundPosition = 'center 0';
		}
	}

	function onScroll() {
		onScrollAnimate();
		onScrollParallax();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initParallax);
	} else {
		initParallax();
	}

	window.addEventListener('load', onScrollAnimate);
	window.addEventListener('scroll', onScroll, { passive: true });

	// 商品ページのスティッキー Add to Cart バー (#shop-bar) の表示制御。
	// shop.js (jQuery) を idle ロードしているため、その scroll handler 到達前にも
	// バーを動かせるよう IntersectionObserver で main の Add to Cart ボタンを観察する。
	// メインボタンがビューポート外に出たらバー表示、戻ったら非表示。
	function initShopBar() {
		// 商品詳細ページ (body.template-product) でのみ shop-bar の出現制御を行う。
		// 他テンプレートで万一 #shop-bar が混入しても誤動作させないためのガード。
		if (!document.body.classList.contains('template-product')) return;
		var bar = document.getElementById('shop-bar');
		if (!bar) return;
		var mainBtn = document.querySelector('.product-form [data-add-to-cart], .product-form .productForm-submit');
		if (!mainBtn) return;
		var bodyEl = document.body;
		if (!('IntersectionObserver' in window)) {
			bar.classList.add('shop-bar--is-visible');
			bodyEl.classList.add('shop-bar-active');
			return;
		}
		var io = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					bar.classList.remove('shop-bar--is-visible');
					bodyEl.classList.remove('shop-bar-active');
				} else {
					bar.classList.add('shop-bar--is-visible');
					bodyEl.classList.add('shop-bar-active');
				}
			});
		}, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
		io.observe(mainBtn);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initShopBar);
	} else {
		initShopBar();
	}
})();
